import Vue from 'vue'
import Router from 'vue-router'
import routeNames from './route-names'
import store from '@/store'

Vue.use(Router)

var router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/app/:instance/complete',
      name: routeNames.RESULT,
      component: () => import(/* webpackChunkName: "result" */ '@/views/Result.vue')
    },
    {
      path: '/app/:instance/refund',
      name: routeNames.REFUND,
      component: () => import(/* webpackChunkName: "refund" */ '@/views/Refund.vue')
    },
    {
      path: '/app/:instance',
      name: routeNames.MAIN,
      component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue')
    },
    {
      path: '/app/:instance/error',
      name: routeNames.ERROR,
      component: () => import(/* webpackChunkName: "error" */ '@/views/Error.vue')
    },
    {
      path: '/not_found',
      name: routeNames.NOT_FOUND,
      component: () => import(/* webpackChunkName: "not_found" */ '@/views/NotFound.vue')
    },
    {
      path: '*',
      redirect: '/not_found'
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.params.instance != null) {
    store.commit('setInstanceId', to.params.instance)
  }
  if (!from.params.instance && !to.params.instance) {
    var navigation = {
      path:
        to.path || window.location.pathname !== '/'
          ? window.location.pathname
          : '/app/',
      params: {
        instance: store.getters.instanceId
      }
    }
    if (navigation.params.instance) {
      to.params.instance = navigation.params.instance
      store.commit('setInstanceId', navigation.params.instance)
    }
    next()
  } else {
    next()
  }
})

export default router
